export default __webpack_public_path__ + "static/media/icon-giftig.b744e1ed.svg";